import { Component } from '@angular/core';
import { CategoryDto } from '../../../dtos/CategoryDto';
import { ProductService } from '../../../services/product.service';
import { ProductDto } from '../../../dtos/ProductDto';

@Component({
  selector: 'app-shop',
  standalone: false,
  templateUrl: './app-shop.component.html',
  styleUrl: './app-shop.component.scss',
  host: {
    class: 'row flex-grow-1'
  }
})
export class ShopComponent {
  products: ProductDto[] = [];
  categories: CategoryDto[] = [];
  selectedCategories: CategoryDto[] = [];

  constructor(
    private productService: ProductService
  ) {
    this.productService.getProducts().subscribe((value: any) => { 
      this.products = value;

      [...new Set(this.products.map(product => product.category))].forEach(category => {
        this.categories.push({
          name: category,
          count: this.products.filter(product => product.category === category).length
        });
      });
    });
  }

  selectCategory(selection: CategoryDto) {
    const index  = this.selectedCategories.findIndex(category => category.name === selection.name);

    if(index !== -1)
      this.selectedCategories.splice(index, 1);
    else
      this.selectedCategories.push(selection);
  }

  containsCategory(selection: CategoryDto) {
    const index  = this.selectedCategories.findIndex(category => category.name === selection.name);

    return index !== -1;
  }

    containsProduct(product: ProductDto) {
    const index  = this.selectedCategories.findIndex(category => category.name === product.category);

    return index !== -1;
  }

  empty(): boolean {
    return !this.products.some((product) => product.quantity > 0);
  }
}
